import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { FileDown, FileText } from "lucide-react";

const Par = ({ par }) => {
  if (typeof par === "object") {
    return (
      <p style={{ fontWeight: par.bold ? 700 : 400, textAlign: par.center ? "center" : "justify" }}>
        {par.text}
      </p>
    );
  }
  return <p style={{ whiteSpace: "pre-wrap" }}>{par}</p>;
};

export default function PreviewDialog({ content, onClose, onGenerate, busy }) {
  return (
    <Dialog open={!!content} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="sm:max-w-3xl max-h-[90vh] flex flex-col" data-testid="document-preview-modal">
        <DialogHeader>
          <DialogTitle>Pregled dokumenta</DialogTitle>
          <DialogDescription>
            Ovako će izgledati vaš dokument. Preuzmite ga kao .docx ili PDF.
          </DialogDescription>
        </DialogHeader>
        {content && (
          <div className="overflow-y-auto border border-slate-200 rounded-lg p-6 sm:p-10 doc-paper shadow-inner">
            {content.logo && (
              <img
                src={content.logo}
                alt="Logotip škole"
                data-testid="document-preview-logo"
                style={{ height: 48, marginBottom: 10 }}
              />
            )}
            {content.header.map((l, i) => (
              <p key={i} style={{ fontWeight: i === 0 ? 700 : 400, textAlign: "left", margin: 0 }}>{l}</p>
            ))}
            {content.meta.map((l, i) => (
              <p key={i} style={{ textAlign: "left", margin: 0 }}>{l}</p>
            ))}
            <p style={{ textAlign: "left", marginTop: 8 }}>{content.place_date}</p>
            {content.recipient.map((l, i) => (
              <p key={i} style={{ textAlign: "right", fontWeight: 700, margin: 0 }}>{l}</p>
            ))}
            <p style={{ textAlign: "center", fontWeight: 700, fontSize: "16px", margin: "22px 0 16px" }}>
              {content.title}
            </p>
            {content.paragraphs.map((par, i) => (
              <Par key={i} par={par} />
            ))}
            {content.attachments.length > 0 && (
              <div style={{ marginTop: 12 }}>
                <p style={{ fontWeight: 700, margin: 0 }}>Prilozi:</p>
                {content.attachments.map((a, i) => (
                  <p key={i} style={{ margin: 0, textAlign: "left" }}>- {a}</p>
                ))}
              </div>
            )}
            {content.signatures.map((s, i) => (
              <div key={i} style={{ textAlign: "right", marginTop: 34 }}>
                <p style={{ margin: 0, textAlign: "right" }}>{s.label}</p>
                <p style={{ margin: "26px 0 0", textAlign: "right" }}>_______________________________</p>
                {s.name && <p style={{ margin: 0, textAlign: "right" }}>{s.name}</p>}
              </div>
            ))}
            {content.stamp && <p style={{ marginTop: 16, textAlign: "left" }}>M.P.</p>}
            {content.legal && (
              <p style={{ marginTop: 26, fontStyle: "italic", fontSize: "11px", color: "#475569", textAlign: "left" }}>
                {content.legal}
              </p>
            )}
          </div>
        )}
        <div className="flex flex-wrap gap-3 pt-2">
          <button
            data-testid="preview-download-docx-btn"
            onClick={() => onGenerate("docx")}
            disabled={busy}
            className="flex items-center gap-2 bg-blue-700 hover:bg-blue-800 text-white font-semibold px-5 py-2.5 rounded-xl shadow-sm transition-all disabled:opacity-50"
          >
            <FileText className="w-4 h-4" />
            Preuzmi .docx
          </button>
          <button
            data-testid="preview-download-pdf-btn"
            onClick={() => onGenerate("pdf")}
            disabled={busy}
            className="flex items-center gap-2 bg-blue-700 hover:bg-blue-800 text-white font-semibold px-5 py-2.5 rounded-xl shadow-sm transition-all disabled:opacity-50"
          >
            <FileDown className="w-4 h-4" />
            Preuzmi PDF
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
